<template>
  <div class="head">
    <ul class="nav-l">
    </ul>
    <div class="title-center"><span>{{ headtitle }}</span></div>
    <ul class="nav-r">
    </ul>
    <AccountInfo :keepalives="kls?true:false" :permissions="permissions"></AccountInfo>
  </div>
</template>

<script>
import AccountInfo from '../layout/account-info';
export default {
  name: 'LayoutHeader2',
  components:{
    AccountInfo
  },
  props: {
    headtitle:{
      type:String,
      default:''
    },
    kls:[Boolean,Array,String],
    permissions:[Array,String]
  },
  data () {
    return {
      nav: [
        {
          name: '驾驶舱',
          url: '/home'
        }, {
          name: '关于久鼎',
          url: '/palletabout'
        }, {
          name: '托盘总览',
          url: '/pallet'
        }, {
          name: '行业分析',
          url: '/palletanalysis'
        }
      ],
      name:'化纤产业大脑'
    }
  },
  mounted() {
    this.name=this.headtitle
  },
  created () {
  },
  methods: {
    hanle(url) {
      this.$router.push(url)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.head{
  background: url("../../assets/hd_bg3.fw.png") no-repeat center;
}
.title-center{
  font-size: 42px;
  font-family:"fzskjt";
  color: #D2DFFF;
  font-style: italic;
  text-shadow: 3px 2px 7px rgba(0,0,0,0.65);
  line-height: 200%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/layout-header2.vue